module.exports = __webpack_public_path__ + "static/media/close-navy.bc23e87e.svg";